<form class="jh-form" [formGroup]="findApplicationFormGroup" #findAppForm="ngForm" (ngSubmit)="onSubmit()">
  <!-- row -->
  <div class="row">

    <!-- Unauthenticated message -->
    <div class="col-12" *ngIf="unauthenticated">

      <!-- Still have attempts message -->
      <div *ngIf="!timeOutFlag">

        <p class="header-4 force-bold fa-unauthenticated-msg">
          <strong>
            We are unable to locate your application based on the information provided. This may happen for several reasons, including:
          </strong>
        </p>

        <ul>

          <li>
            The credentials you are entering do not match what your insurance agent entered into the application (most common)
          </li>

          <li>
            You have already signed your application
          </li>

          <li>
            The application is more than 90 days old
          </li>
        </ul>

        <p class="header-4 force-bold fa-unauthenticated-msg">
          <strong>
            Please contact your insurance agent for further assistance.
          </strong>
        </p>

      </div>

      <!-- Timeout message -->
      <div *ngIf="timeOutFlag">

        <p class="header-4 force-bold fa-unauthenticated-msg">
          <strong>
            {{errorMsg}}
          </strong>
        </p>

      </div>

    </div>
    
    <!-- Header text -->
    <div class="col-12">
      <p class="header-4 force-bold fa-header"> <strong>To get started, please enter the following information.</strong> </p>
    </div>
    <!-- /Header text -->
  </div>
  <!-- /row -->

  <div class="loading-overlay"  *ngIf="processing">
    <div class="spinner-wrapper text-center show">
      <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
    </div><!-- /spinner -->
  </div>
<!--proposed insured-->

  <!-- row -->
  <div class="row" *ngIf="ownerType!='IndividualOwner' && ownerType!='BusinessSignator' && ownerType!='EntityTrustee' && ownerType!='IndividualTrustee' && ownerType!='Other'">
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-lastName-input">Last Name <span class="asterisk">*</span></label>
        <input id="find-application-lastName-input" aria-required='true' type="text" class="form-control lastname" name="lastName" formControlName="lastName" [(ngModel)]="lastName" placeholder="Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="lastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-ss-input">Social Security Number <span class="asterisk">*</span></label>
        <div class="ssn-wrapper">
          <input id="find-application-ss-input" aria-required='true' [type]="ssnType" class="form-control" name="ssn" formControlName="ssn" [(ngModel)]="ss" placeholder="XXX-XX-XXXX" maxlength="11" [textMask]="{mask: maskSs, guide: false}" (keypress)="ssnType='text'" (blur)="ssnType='password'" >
          <i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i>
        </div>
        <error-messages [form]="findApplicationFormGroup" field="ssn"></error-messages>
       </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-zip-input">Zip Code <span class="asterisk">*</span></label>
        <input id="find-application-zip-input" aria-required='true' type="text" class="form-control" name="zip" formControlName="zip" [(ngModel)]="zip" placeholder="XXXXX" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null"   maxlength="5" [textMask]="{mask: maskZip, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="zip"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-dob-input">Date of Birth <span class="asterisk">*</span></label>
          <input id="find-application-dob-input" aria-required='true' type="text" class="form-control" name="dob" formControlName="dob" [(ngModel)]="dob" placeholder="MM/DD/YYYY" [textMask]="{mask: maskDob, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="dob"></error-messages>
      </div>
    </div>
  </div>

<!--owners-->
  <!-- row -->
  <div class="row" *ngIf="ownerType == 'IndividualOwner'">
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-owner-insured-lastName-input">Insured Last Name <span class="asterisk">*</span></label>
        <input id="find-application-owner-insured-lastName-input" type="text" class="form-control lastname" name="insuredLastName" formControlName="insuredLastName" [(ngModel)]="insuredLastName" placeholder="Insured Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="insuredLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-owner-lastName-input">Owner Last Name <span class="asterisk">*</span></label>
        <input id="find-application-owner-lastName-input" type="text" class="form-control lastname" name="ownerLastName" formControlName="ownerLastName" [(ngModel)]="ownerLastName" placeholder="Owner Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="ownerLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-owner-ss-input">Owner Social Security Number <span class="asterisk">*</span></label>
        <div class="ssn-wrapper">
          <input id="find-application-owner-ss-input" [type]="ssnType" class="form-control" name="ownerSsn" formControlName="ownerSsn" [(ngModel)]="ownerSs" placeholder="XXX-XX-XXXX" maxlength="11" [textMask]="{mask: maskSs, guide: false}" (keypress)="ssnType='text'" (blur)="ssnType='password'" >
          <i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i>
        </div>
        <error-messages [form]="findApplicationFormGroup" field="ownerSsn"></error-messages>
       </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-owner-zip-input">Owner Zip Code <span class="asterisk">*</span></label>
        <input id="find-application-owner-zip-input" type="text" class="form-control" name="ownerZip" formControlName="ownerZip" [(ngModel)]="ownerZip" placeholder="XXXXX" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null"   maxlength="5" [textMask]="{mask: maskZip, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="ownerZip"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-ownerdob-input">Owner Date of Birth <span class="asterisk">*</span></label>
          <input id="find-application-ownerdob-input" type="text" class="form-control" name="ownerDob" formControlName="ownerDob" [(ngModel)]="ownerDob" placeholder="MM/DD/YYYY" [textMask]="{mask: maskDob, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="ownerDob"></error-messages>
      </div>
    </div>
  </div>
  <!--BUSINESS SIGNATOR row -->
 <div class="row" *ngIf="ownerType == 'BusinessSignator'">
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-biz-lastName-input">Insured Last Name <span class="asterisk">*</span></label>
        <input id="find-application-biz-lastName-input" type="text" class="form-control lastname" name="insuredLastName" formControlName="insuredLastName" [(ngModel)]="insuredLastName" placeholder="Insured Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="insuredLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-biz-signator-lastName-input">Signer Last Name <span class="asterisk">*</span></label>
        <input id="find-application-biz-signator-lastName-input" type="text" class="form-control lastname" name="signatorLastName" formControlName="signatorLastName" [(ngModel)]="signatorLastName" placeholder="Signator Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="signatorLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-biz-ss-input">Business Tax ID<span class="asterisk">*</span></label>
        <div class="ssn-wrapper">
          <input id="find-application-biz-ss-input" [type]="ssnType" class="form-control" name="signatorTaxId" formControlName="signatorTaxId" [(ngModel)]="signatorTaxId" placeholder="XX-XXXXXXX" maxlength="10" [textMask]="{mask: maskEin, guide: false}" (keypress)="ssnType='text'" (blur)="ssnType='password'" >
          <i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i>
        </div>
        <error-messages [form]="findApplicationFormGroup" field="signatorTaxId"></error-messages>
       </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-biz-zip-input">Business Zip Code <span class="asterisk">*</span></label>
        <input id="find-application-biz-zip-input" type="text" class="form-control" name="signatorZip" formControlName="signatorZip" [(ngModel)]="signatorZip" placeholder="XXXXX" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null"   maxlength="5" [textMask]="{mask: maskZip, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="signatorZip"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-biz-dob-input">Signer Date of Birth <span class="asterisk">*</span></label>
          <input id="find-application-biz-dob-input" type="text" class="form-control" name="signatorDob" formControlName="signatorDob" [(ngModel)]="signatorDob" placeholder="MM/DD/YYYY" [textMask]="{mask: maskDob, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="signatorDob"></error-messages>
      </div>
    </div>
  </div>
  <!-- Other Owner row-->
  <div class="row" *ngIf="ownerType == 'Other'">
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-other-owner-lastName-input">Insured Last Name <span class="asterisk">*</span></label>
        <input id="find-application-other-owner-lastName-input" type="text" class="form-control lastname" name="insuredLastName" formControlName="insuredLastName" [(ngModel)]="insuredLastName" placeholder="Insured Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="insuredLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-other-owner-signator-lastName-input">Signer Last Name <span class="asterisk">*</span></label>
        <input id="find-application-other-owner-signator-lastName-input" type="text" class="form-control lastname" name="signatorLastName" formControlName="signatorLastName" [(ngModel)]="signatorLastName" placeholder="Signator Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="signatorLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-other-owner-ss-input">Entity Tax ID<span class="asterisk">*</span></label>
        <div class="ssn-wrapper">
          <input id="find-application-other-owner-ss-input" [type]="ssnType" class="form-control" name="signatorTaxId" formControlName="signatorTaxId" [(ngModel)]="signatorTaxId" placeholder="XX-XXXXXXX" maxlength="11" [textMask]="{mask: maskEin, guide: false}" (keypress)="ssnType='text'" (blur)="ssnType='password'" >
          <i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i>
        </div>
        <error-messages [form]="findApplicationFormGroup" field="signatorTaxId"></error-messages>
       </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-other-owner-zip-input">Entity Zip Code <span class="asterisk">*</span></label>
        <input id="find-application-other-owner-zip-input" type="text" class="form-control" name="signatorZip" formControlName="signatorZip" [(ngModel)]="signatorZip" placeholder="XXXXX" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null"   maxlength="5" [textMask]="{mask: maskZip, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="signatorZip"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-other-owner-dob-input">Signer Date of Birth <span class="asterisk">*</span></label>
          <input id="find-application-other-owner-dob-input" type="text" class="form-control" name="signatorDob" formControlName="signatorDob" [(ngModel)]="signatorDob" placeholder="MM/DD/YYYY" [textMask]="{mask: maskDob, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="signatorDob"></error-messages>
      </div>
    </div>
  </div>
  <!-- ENTITY TRUSTEE row -->
  <div class="row" *ngIf="ownerType == 'EntityTrustee'">
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-trustee-lastName-input">Insured Last Name <span class="asterisk">*</span></label>
        <input id="find-application-trustee-lastName-input" type="text" class="form-control lastname" name="insuredLastName" formControlName="insuredLastName" [(ngModel)]="insuredLastName" placeholder="Insured Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="insuredLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-trustee-signator-lastName-input">Signer Last Name <span class="asterisk">*</span></label>
        <input id="find-application-trustee-signator-lastName-input" type="text" class="form-control lastname" name="signatorLastName" formControlName="signatorLastName" [(ngModel)]="signatorLastName" placeholder="Signator Last Name" >
        <error-messages [form]="findApplicationFormGroup" field="signatorLastName"></error-messages>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-trustee-ss-input">Entity Trustee Taxation Identification Number<span class="asterisk">*</span></label>
        <div class="ssn-wrapper">
          <input id="find-application-trustee-ss-input" [type]="ssnType" class="form-control" name="trusteeEin" formControlName="trusteeEin" [(ngModel)]="trusteeEin" placeholder="XX-XXXXXXX" maxlength="10" [textMask]="{mask: maskEin, guide: false}" (keypress)="ssnType='text'" (blur)="ssnType='password'" >
          <i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i>
        </div>
        <error-messages [form]="findApplicationFormGroup" field="trusteeEin"></error-messages>
       </div>
    </div>
    <!-- /item -->
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-trustee-dob-input">Signer Date of Birth <span class="asterisk">*</span></label>
          <input id="find-application-trustee-dob-input" type="text" class="form-control" name="signatorDob" formControlName="signatorDob" [(ngModel)]="signatorDob" placeholder="MM/DD/YYYY" [textMask]="{mask: maskDob, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="signatorDob"></error-messages>
      </div>
    </div> 
    <!-- item -->
    <div class="col-12">
      <div class="form-group">
        <label for="find-application-trustee-zip-input">Entity Trustee Zip Code <span class="asterisk">*</span></label>
        <input id="find-application-trustee-zip-input" type="text" class="form-control" name="trusteeZip" formControlName="trusteeZip" [(ngModel)]="trusteeZip" placeholder="XXXXX" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null"   maxlength="5" [textMask]="{mask: maskZip, guide: false}">
        <error-messages [form]="findApplicationFormGroup" field="trusteeZip"></error-messages>
      </div>
    </div>
    <!-- /item -->
  </div>




    <!-- INDIVIDUAL TRUSTEE row -->
    <div class="row" *ngIf="ownerType == 'IndividualTrustee'">
      <!-- item -->
      <div class="col-12">
        <div class="form-group">
          <label for="find-application-individual-trustee-insured-lastName-input">Insured Last Name <span class="asterisk">*</span></label>
          <input id="find-application-individual-trustee-insured-lastName-input" type="text" class="form-control lastname" name="insuredLastName" formControlName="insuredLastName" [(ngModel)]="insuredLastName" placeholder="Insured Last Name" >
          <error-messages [form]="findApplicationFormGroup" field="insuredLastName"></error-messages>
        </div>
      </div>
      <!-- /item -->
  
      <!-- item -->
      <div class="col-12">
        <div class="form-group">
          <label for="find-application-individual-trustee-lastName-input">Trustee Last Name <span class="asterisk">*</span></label>
          <input id="find-application-individual-trustee-lastName-input" type="text" class="form-control lastname" name="trusteeLastName" formControlName="trusteeLastName" [(ngModel)]="trusteeLastName" placeholder="Trustee Last Name" >
          <error-messages [form]="findApplicationFormGroup" field="trusteeLastName"></error-messages>
        </div>
      </div>
      <!-- /item -->
  
      <!-- item -->
      <div class="col-12">
        <div class="form-group">
          <label for="find-application-individual-trustee-ss-input">Trustee Social Security Number <span class="asterisk">*</span></label>
          <div class="ssn-wrapper">
            <input id="find-application-individual-trustee-ss-input" [type]="ssnType" class="form-control" name="trusteeSsn" formControlName="trusteeSsn" [(ngModel)]="trusteeSsn" placeholder="XXX-XX-XXXX" maxlength="11" [textMask]="{mask: maskSs, guide: false}" (keypress)="ssnType='text'" (blur)="ssnType='password'" >
            <i class="fas fa-eye" (mousedown)="ssnType='text'" (mouseup)="ssnType='password'"></i>
          </div>
          <error-messages [form]="findApplicationFormGroup" field="trusteeSsn"></error-messages>
         </div>
      </div>
      <!-- /item -->
   <!-- item -->
      <div class="col-12">
        <div class="form-group">
          <label for="find-application-individual-trustee-dob-input">Trustee Date of Birth <span class="asterisk">*</span></label>
            <input id="find-application-individual-trustee-dob-input" type="text" class="form-control" name="trusteeDob" formControlName="trusteeDob" [(ngModel)]="trusteeDob" placeholder="MM/DD/YYYY" [textMask]="{mask: maskDob, guide: false}">
          <error-messages [form]="findApplicationFormGroup" field="trusteeDob"></error-messages>
        </div>
      </div>
            <!-- item -->
            <div class="col-12">
              <div class="form-group">
                <label for="find-application-individual-trustee-zip-input">Trustee Zip Code <span class="asterisk">*</span></label>
                <input id="find-application-individual-trustee-zip-input" type="text" class="form-control" name="trusteeZip" formControlName="trusteeZip" [(ngModel)]="trusteeZip" placeholder="XXXXX" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null"   maxlength="5" [textMask]="{mask: maskZip, guide: false}">
                <error-messages [form]="findApplicationFormGroup" field="trusteeZip"></error-messages>
              </div>
            </div>
            <!-- /item -->
    </div>

  
     
  <!-- row -->
  <div class="row fa-link-wrapper">
      <!-- Consent to Complete Life Insurance Transaction text -->
      <div class="col-12">
        <div class="find-application-header">
          <p class="header-4" style="font-weight: 500 !important;" id="find-application-consent-header">Please read the <a href="" (click)="consentLinkClick($event)" name="consent">Consent to Complete Life Insurance Transaction Electronically</a></p>
        </div>
      </div>
  </div>
  <!-- /row -->

  <!-- row -->
  <div class="row">
      <!-- checkbox -->
      <div class="col-12">
        <div class="checkbox-wrapper">
          <mat-checkbox id="find-application-checkbox" color="green"(change)="onCheckboxChange()" name="consentCheckBox" formControlName="consentCheckBox" field="consentCheckBox" required>
            <p> I agree to the above consent, including electronic delivery of disclosures and using electronic signatures in this transaction </p>
          </mat-checkbox>
        </div>
        <error-messages [form]="findApplicationFormGroup" field="consentCheckBox"></error-messages>
      </div>
  </div>
  <!-- /row -->


    <!-- row -->
  <div class="row">
    <!-- Submit button -->
    <div class="col-12">
      <div class="button-wrapper button-wrapper-next-previous text-center">
        <button id="find-application-next-btn" class="btn btn-primary text-center" type="submit" [disabled]="!findAppForm.valid">Submit</button>
      </div>
    </div>
  </div>


</form>
